<template>
  <div>
    <div
      class="noticebar-vertical"
      v-if="scrollList.length > 0"
      :style="barStyle"
    >
      <template>
        <ul class="horseLamp_list" :style="horseLampStyle">
          <li
            class="horseLamp_list_item"
            v-for="(item, index) in scrollList"
            :key="index"
            :style="{
              height: height,
              color: mValue?.fontColor,
              fontSize: mValue?.fontSize / 7.5 + 'vw'
            }"
          >
            恭喜<b :style="{ color: mValue?.focusFontColor }">{{
              item.role_name
            }}</b
            >获得<b :style="{ color: mValue?.focusFontColor }">{{
              item.prize_name
            }}</b>
          </li>
        </ul>
      </template>
    </div>
    <div class="empty" v-else>暂无中奖记录</div>
  </div>
</template>

<script>
export default {
  name: 'ScrollMarquee',
  props: {
    //数据源
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    //停留时间（毫秒）
    standTime: {
      type: Number,
      default: 1000
    },
    //每一个滚动列的高度(px)
    height: {
      type: Number,
      default: 40
    },
    //滚动速率 (px/s)
    speed: {
      type: Number,
      default: 50
    },
    marquee: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      animate: false,
      scrollList: [],
      timer: null,
      mValue: null
    };
  },
  computed: {
    barStyle() {
      return {
        color: this.color,
        height: `${this.height / 7.5}vw`
      };
    },
    horseLampStyle() {
      let styles = {};
      if (this.animate) {
        styles = {
          transition: `all ${~~(this.height / this.speed / 4)}s`,
          'margin-top': `-${this.height / 7.5}vw`
        };
      }
      return styles;
    }
  },
  watch: {
    marquee: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        this.mValue = newVal;
        console.log(oldVal);
      }
    },
    list(newValue, oldValue) {
      this.scrollList = [].concat(newValue);
      console.log(oldValue);
    }
  },
  mounted() {
    this.scrollList = [].concat(this.list);
    setTimeout(() => {
      this.startRollEasy();
    }, this.standTime);
  },
  methods: {
    /**
     * 利益点滚动方式一
     */
    startRollEasy() {
      this.showhorseLamp();
      this.timer = setInterval(
        this.showhorseLamp,
        ~~(this.height / this.speed / 4) * 1000 + this.standTime
      );
    },
    showhorseLamp() {
      this.animate = true;
      setTimeout(() => {
        this.scrollList.push(this.scrollList[0]);
        this.scrollList.shift();
        this.animate = false;
      }, ~~(this.height / this.speed / 4) * 1000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="scss">
// 垂直方向的滚动
@keyframes nut-notice-bar-play-vertical {
  to {
    transform: translateY(40px);
  }
}

// 纵向
.noticebar-vertical {
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  padding: 0 80px;
  box-sizing: border-box;
  overflow: hidden;

  .horseLamp_list {
    display: block;
    flex: 1;

    .horseLamp_list_item {
      text-align: center;
      height: 40px;
      font-size: 22px;
      color: #fff;
    }
  }
}
.empty {
  color: #fff;
  font-size: 22px;
  text-align: center;
  height: 40px;
  line-height: 40px;
}
</style>
